/**
 * EIN WORT FUER DIE VERFUEGBARKEIT -- an einer Stelle.
 *
 * DER ANLASS
 *
 * TP154 stand produktiv mit Bestand 0 und `availability = nicht_verfuegbar`.
 * Die Artikelliste sagte "Nicht verfügbar". Die Detailansicht sagte im selben
 * Moment "Verfügbar · 0 Stück".
 *
 * Beide lasen dieselbe Datenbank. Der Unterschied lag nicht in den Daten,
 * sondern darin, dass die Detailansicht ueberhaupt keine Aussage MACHTE: dort
 * stand "Verfügbar" als feste Ueberschrift ueber der Mengenzeile -- gemeint
 * war "verfuegbare Menge", gelesen wurde "dieser Artikel ist verfuegbar". Bei
 * jeder Zahl ueber null faellt das nicht auf. Bei null wird daraus eine
 * Zusage, die das Lager nicht deckt.
 *
 * WARUM DAS HIER STEHT UND NICHT ZWEIMAL
 *
 * Eine Beschriftung, die aussieht wie eine Aussage, ist eine Aussage. Und
 * eine Aussage darf es nur einmal geben. Die Liste hat diese Funktion
 * mitgebracht; sie steht jetzt so, dass beide Ansichten dasselbe Wort aus
 * demselben Feld ziehen -- `operationalState.availability`, abgeleitet in der
 * Sicht `article_operational_status`.
 *
 * DIE DRITTE MOEGLICHKEIT IST KEINE LUECKE
 *
 * `keine_aussage` heisst: es ist keine Bestandsquelle angeschlossen. Das ist
 * NICHT dasselbe wie "nicht verfuegbar" -- niemand hat etwas gemeldet, also
 * behauptet auch niemand etwas. Das Wort dafuer sagt genau das.
 */
import type { Availability } from "@homebase/shared";
import type { I18n } from "../i18n/index.tsx";

export function verfuegbarkeitswort(v: Availability, t: I18n["t"]): string {
  if (v === "verfuegbar") return t("list.availabilityYes");
  if (v === "nicht_verfuegbar") return t("list.availabilityNo");
  return t("list.availabilityUnknown");
}
